import React, { useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { InlineLoading } from '@carbon/react';
import { useAuth } from '../context/AuthContext';
import FlowEditor from '../features/etl/pages/FlowEditor';
import '../features/etl/etl-flow.css';

const EtlFlowPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading } = useAuth();

  const handleBack = useCallback(() => {
    navigate('/dashboard/pipelines');
  }, [navigate]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '48px' }}>
        <InlineLoading description="Loading pipeline editor..." />
      </div>
    );
  }

  if (!id) {
    navigate('/dashboard/pipelines', { replace: true });
    return null;
  }

  return (
    <div className="etl-flow-page">
      <FlowEditor
        embedded
        flowId={id}
        onBack={handleBack}
      />
    </div>
  );
};

export default EtlFlowPage;
